import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { NotePage } from 'pages/note-page/note-page';

@NgModule({
  declarations: [NotePage],
  imports: [PagesModule, ComponentsModule],
  exports: [NotePage]
})
export class NotePageModule { }
